/* eslint-disable */
import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "ScheduleManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      schedules: [],
      editIndex: null,
      editableRow: null,
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: "",
      protocolId: "",
      currentPage: 1,
      pageSize: 10,
      pageindex: 1,
      SortProperty: "visitNo",
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
      validationErrors: {},
      protocol: {},
      isAddingNew: false,
      newRow: {
        visitNo: "",
        preVisit: "",
        postVisit: "",
        visitPeriodDay: "",
        visitPeriodWeek: "",
        visitPeriodMonth: "",
        visitPeriodYear: "",
      },
      newRowErrors: {},
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;
    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.ListSchedules(this.protocolId);
    }
  },
  methods: {
    async ListSchedules(protocolId) {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/studyprotocol/listdaschedules?protocolId=${protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.schedules = response.data.results;
        this.totalCount = response.data.totalCount;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);
      } catch (error) {
        console.error("Error in fetching schedules:", error);
      }
    },
    editRow(index, schedule) {
      this.editIndex = index;
      this.editableRow = { ...schedule };
    },
    validateRow() {
      this.validationErrors = {};
      let isValid = true;

      if (!this.editableRow.visitNo) {
        this.validationErrors.visitNo = "Visit Number is required.";
        isValid = false;
      }

      return isValid;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async updateRow(index, studyId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          scheduleId: index,
          studyId: studyId,
          visitNo: this.editableRow.visitNo,
          preVisit: this.editableRow.preVisit.toString(),
          postVisit: this.editableRow.postVisit.toString(),
          visitPeriodDay: this.editableRow.visitPeriodDay.toString(),
          visitPeriodWeek: this.editableRow.visitPeriodWeek.toString(),
          visitPeriodMonth: this.editableRow.visitPeriodMonth.toString(),
          visitPeriodYear: this.editableRow.visitPeriodYear.toString(),
          soaId: this.editableRow.soaId,
          protocolRefId: this.protocolId,
        };
        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedaschedule`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        this.schedules[index] = { ...this.editableRow };
        this.cancelEdit();

        alert("Schedule details updated successfully.");
        await this.getProtocolbyId();
        await this.ListSchedules(this.protocolId);
      } catch (error) {
        console.error("Error during schedule update API call:", error);
        alert("Failed to update the schedule. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      await this.ListSchedules(this.protocolId);
    },
    async deleteRow(id) {
      try {
        const confirmation = confirm(
          "Are you sure you want to delete this schedule?"
        );
        if (!confirmation) {
          return;
        }

        const response = await axios.delete(
          `${
            this.baseurl
          }/management/studyprotocol/deletebyid?collectionName=${"DaScrape_Schedule"}&id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Delete response:", response.data);
         alert("Schedule deleted successfully");
        await this.ListSchedules(this.protocolId);
         if (this.schedules.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
        await this.ListSchedules(this.protocolId);
    }

       
      } catch (error) {
        console.error("Error during schedule delete API call:", error);
        alert("Failed to delete the schedule. Please try again.");
      }
    },
    checknegative() {
      if (this.editableRow.preVisit < 0) {
        this.editableRow.preVisit = 0;
      }
      if (this.editableRow.postVisit < 0) {
        this.editableRow.postVisit = 0;
      }
      if (this.editableRow.visitPeriodDay < 0) {
        this.editableRow.visitPeriodDay = 0;
      }
      if (this.editableRow.visitPeriodWeek < 0) {
        this.editableRow.visitPeriodWeek = 0;
      }
      if (this.editableRow.visitPeriodMonth < 0) {
        this.editableRow.visitPeriodMonth = 0;
      }
      if (this.editableRow.visitPeriodYear < 0) {
        this.editableRow.visitPeriodYear = 0;
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("protocol", res.data);
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = {
        visitNo: "",
        preVisit: "",
        postVisit: "",
        visitPeriodDay: "",
        visitPeriodWeek: "",
        visitPeriodMonth: "",
        visitPeriodYear: "",
        soaId: "",
      };
      this.newRowErrors = {};
      // Cancel any active inline edit
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.visitNo) {
        this.newRowErrors.visitNo = "Visit Number is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    checkNewNegative() {
      if (this.newRow.preVisit < 0) this.newRow.preVisit = 0;
      if (this.newRow.postVisit < 0) this.newRow.postVisit = 0;
      if (this.newRow.visitPeriodDay < 0) this.newRow.visitPeriodDay = 0;
      if (this.newRow.visitPeriodWeek < 0) this.newRow.visitPeriodWeek = 0;
      if (this.newRow.visitPeriodMonth < 0) this.newRow.visitPeriodMonth = 0;
      if (this.newRow.visitPeriodYear < 0) this.newRow.visitPeriodYear = 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_Schedule",
          data: {
            protocolRefId: this.protocolId,
            visitNo: this.newRow.visitNo,
            soaId: this.newRow.soaId,
            preVisit: this.newRow.preVisit
              ? this.newRow.preVisit.toString()
              : "0",
            postVisit: this.newRow.postVisit
              ? this.newRow.postVisit.toString()
              : "0",
            visitPeriodDay: this.newRow.visitPeriodDay
              ? this.newRow.visitPeriodDay.toString()
              : "0",
            visitPeriodWeek: this.newRow.visitPeriodWeek
              ? this.newRow.visitPeriodWeek.toString()
              : "0",
            visitPeriodMonth: this.newRow.visitPeriodMonth
              ? this.newRow.visitPeriodMonth.toString()
              : "0",
            visitPeriodYear: this.newRow.visitPeriodYear
              ? this.newRow.visitPeriodYear.toString()
              : "0",
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};
        await this.ListSchedules(this.protocolId);

        alert("Schedule created successfully.");
      } catch (err) {
        console.error("Error creating schedule:", err);
        alert("Failed to create schedule. Please try again.");
      }
    },
  },
};
